import React from 'react';
import { fetchSeImpactAnalytics } from '../../../../Redux/Constants/apiService';
import ImpactAnalyticsEmbed from './ImpactAnalyticsEmbed';

export const SE_IMPACT_EMBED_HEIGHT_MESSAGE = 'se-impact-embed-height';

const SalesImpactAnalytics = () => (
  <ImpactAnalyticsEmbed
    fetchHtml={fetchSeImpactAnalytics}
    embedHeightMessage={SE_IMPACT_EMBED_HEIGHT_MESSAGE}
    embedStyleId="se-impact-embed-style"
    embedResizerId="se-impact-embed-resizer"
    loadingText="Loading SE Activities & Impact Analysis Analytics"
    iframeTitle="SE Activities & Impact Analysis"
    loadErrorFallback="Unable to load SE Activities & Impact Analysis Analytics."
  />
);

export default SalesImpactAnalytics;
